import { buildDispatchable } from '../../actions/_action-utilities';
import * as dictionaryActions from '../../actions/dictionary';
import * as dictionaryValueActions from '../../actions/dictionary-values';
import history from '../../history';
import { commonEnums, AmplifyCore } from '@codametrix/ui-common';
import { isResourceViewOnly } from '../../core/resources';
const { ResourceId } = commonEnums;
export const mapStateToProps = function(state) {
    const { dictionary, ui } = state;
    let adminTabs = ui.actionGroups.find((actionGroup)=>{
        return actionGroup.key === 'admin';
    })?.options[0].subActions.filter((tab)=>{
        return ui.context.activeContext ? AmplifyCore.benchEditable.isResourceAllowed(ui.context.activeContext, tab.resourceId, ui.context.activeContext.serviceLineName ?? '') : false;
    }) ?? [];
    const viewOnly = isResourceViewOnly(ui.context.activeContext?.resources || [], ResourceId.DICTIONARY);
    return {
        ...dictionary,
        selectedOrg: dictionary.selectedOrg,
        showHeader: adminTabs?.length <= 1,
        viewOnly
    };
};
export const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        onSelection: (item)=>{
            runDispatchable(()=>{
                return dispatch(dictionaryActions.loadDictionary(item));
            });
        },
        list: (listParams)=>{
            runDispatchable(()=>{
                return dispatch(dictionaryActions.listItems(listParams));
            });
        },
        navigate: (path)=>{
            runDispatchable(()=>{
                history.push(path);
            });
        },
        resetStateToDefault: (payload)=>{
            runDispatchable(()=>{
                return dispatch(dictionaryValueActions.syncActions.updateDictionaryValue(payload));
            });
        }
    };
};
export const optionConverter = (field)=>{
    const { options, labelField, valueField } = field;
    let opts = [];
    options?.map((item)=>{
        opts?.push({
            label: item[labelField],
            value: item[valueField]
        });
        return {};
    });
    return opts;
};
export const jiraTicketRegex = /^[a-zA-Z]+-\d+$/;
